import { computed, getCurrentScope, onScopeDispose, shallowRef } from 'vue'
import { isPhoneWorkspace, observeDisplayState, readDisplayState } from './displayState'

const displayState = shallowRef(readDisplayState())
const phoneWorkspaceLayout = computed(() => isPhoneWorkspace(displayState.value))
let observer = null
let consumers = 0

export function useDisplayState() {
  // A standalone page is a valid owner; there is no dependency on Layout or
  // provide/inject. Calls without a Vue scope only read, so they cannot leak.
  if (!getCurrentScope()) {
    if (!observer) displayState.value = readDisplayState()
    return { displayState, phoneWorkspaceLayout }
  }
  consumers += 1
  if (!observer) {
    observer = observeDisplayState(next => { displayState.value = next })
  }
  onScopeDispose(() => {
    consumers -= 1
    if (consumers === 0) {
      observer?.stop()
      observer = null
    }
  })
  return { displayState, phoneWorkspaceLayout }
}
